import { render, staticRenderFns } from "./SpouseRiderWidget.vue?vue&type=template&id=5c0a97ad&scoped=true"
import script from "./SpouseRiderWidget.vue?vue&type=script&lang=js"
export * from "./SpouseRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./SpouseRiderWidget.vue?vue&type=style&index=0&id=5c0a97ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a97ad",
  null
  
)

export default component.exports